import { Component } from '@angular/core';
import { NavController,App } from 'ionic-angular';
import { AddCalendarPage } from '../addcalendar/addcalendar';

import { WebService } from '../../../providers/service/webservice';
import { SAVEORUPDATE,QUERYCALENDAR } from '../../../providers/config/serviceurl';

import { Utils } from '../../../providers/service/utils';
import { StorageService } from '../../../providers/service/storageservice';
import { AppState } from '../../../app/app.global';

@Component({
  selector: 'page-tripSet',
  templateUrl: 'tripset.html'
})
export class TripSetPage {

	currentUser:any;
	navTitle :string;
	navType:string;
	privateCalendars :any[];
	publicCalendars :any[];

	//saveOrUpdateUrl = APP_SERVE_URL+'home/nTrip/saveOrUpdate.action';
	//queryUrl = APP_SERVE_URL+"home/nTrip/queryCalendars.action";

  constructor(public navCtrl: NavController,private appCtrl :App,private webService:WebService,public global: AppState) {
			this.queryList();
  }

  //查询数据
  queryList(){
  	  this.currentUser = StorageService.getObj("currentUser");
  		var params = {'userId':this.currentUser.userId};
			//this.webService.post(QUERYCALENDAR,params,"查询日历").then(anyObj =>this.handleThings(anyObj));
  }
  //处理数据
  handleThings(obj :any){
		if(obj){
			this.privateCalendars = obj.privateCalendars;
			if(this.privateCalendars){
				for(var i=0;i<this.privateCalendars.length;i++){
					this.privateCalendars[i].isShow = Utils.formatTrueOrFalse(this.privateCalendars[i].isShow);
					this.privateCalendars[i].isRemind = Utils.formatTrueOrFalse(this.privateCalendars[i].isRemind);
				}
			}

			this.publicCalendars = obj.publicCalendars;
			if(this.publicCalendars){
				for( i=0;i<this.publicCalendars.length;i++){
					this.publicCalendars[i].isShow = Utils.formatTrueOrFalse(this.publicCalendars[i].isShow);
					this.publicCalendars[i].isRemind = Utils.formatTrueOrFalse(this.publicCalendars[i].isRemind);
				}
			}
		}
	}
  //新增
  addCalendar(){
  	this.navTitle = '新增';
  	this.appCtrl.getRootNav().push(AddCalendarPage, { privateCalendars: this.privateCalendars,navTitle:this.navTitle,navType:'private' });
  }
  //修改
  editCalendar(calendar:any,type:string){
  	this.navTitle = '编辑';
  	if(type=='public'){
  		this.appCtrl.getRootNav().push(AddCalendarPage, { calendar:calendar,navTitle:this.navTitle,navType:type});
  	}else{
  		this.appCtrl.getRootNav().push(AddCalendarPage, { privateCalendars: this.privateCalendars,calendar:calendar,navTitle:this.navTitle,navType:type});
  	}
  }
  saveOrUpdate(calendar:any){
		var params = {'userId':this.currentUser.userId,
									'id':calendar.id,
									'name':Utils.base64Encode(calendar.name),
									'color':calendar.color,
									'isShow':Utils.formatOneOrZreo(calendar.isShow),
									'isRemind':Utils.formatOneOrZreo(calendar.isRemind),
									'type':calendar.type,
		};
		this.webService.post(SAVEORUPDATE,params,"新增更新");
  }
}



// WEBPACK FOOTER //
// ./src/pages/trip/set/tripset.ts